import { render } from "./CreatePassword.vue?vue&type=template&id=40eb9f85&scoped=true&ts=true"
import script from "./CreatePassword.vue?vue&type=script&lang=ts"
export * from "./CreatePassword.vue?vue&type=script&lang=ts"

import "./CreatePassword.vue?vue&type=style&index=0&id=40eb9f85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40eb9f85"]])

export default __exports__